module.exports = __webpack_public_path__ + "img/GTM.8b9f698e.svg";